// Logger seguro para produção
// Só mostra logs detalhados em desenvolvimento

const isDevelopment =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_ENV === 'development' ||
  /^(localhost|127\.0\.0\.1|0\.0\.0\.0|\[::1\])$/.test(window.location.hostname);

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  debug: (...args) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    } else {
      console.error('Erro na aplicação - verifique logs do servidor');
    }
  },
  
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  }
};

// Exportações nomeadas para facilitar uso
export const devLog = logger.log;
export const devDebug = logger.debug;
export const devError = logger.error;
export const devWarn = logger.warn;

export default logger;